import React from 'react';
import PageHeader from './PageHeader';

interface DashboardHeaderProps {
  selectedSchool?: string;
  onSchoolChange?: (school: string) => void;
}

// 保持向后兼容，但使用新的PageHeader组件
const DashboardHeader: React.FC<DashboardHeaderProps> = (props) => {
  return <PageHeader />;
};

export default DashboardHeader;